import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		edit: {
			panel: {
				width: '70%',
				modal: true
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		list: {
			config: {
				sorting: true,
				fields: {
					id: {
						config: {
							visible: false,
							sorting: 'document_inventory_types.id'
						}
					},
					display_number: {
						config: {
							description: 'Номер',
							visible: true,
							sorting: 'document_inventory_types.display_number'
						}
					},
					name: {
						config: {
							visible: true,
							sorting: 'document_inventory_types.name'
						}
					}
				}
			},
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		select: {
			panel: {
				width: '70%',
				height: '500px'
			},
			config: {
				fields: {
					id: {
						config: {
							width: '100px'
						}
					},
					name: {
					}
				}
			}
		}
	}
}


